import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions from '../../actions';
import { Card } from '@shopify/polaris';
import './styles.scss';
import solutions from './solutions';
import { CONFIG } from '../../config';

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

class Support extends Component {
    render() {
        const { actions } = this.props;

        return (
            <div className="yta-support">
                <Card.Section>
                    <div className="yta-support-head">{CONFIG.APP_NAME}</div>
                    <div className="yta-support-body">
                        {solutions.map((item, index) => (
                            <div key={index} className="item">
                                <div className="item-head">
                                    <a href={item.url} target="_blank">
                                        {item.title}
                                    </a>
                                    <span>
                                        <sup>({item.items.length})</sup>
                                    </span>
                                </div>
                                <div className="item-body">
                                    {item.items.map((_item, _index) => (
                                        <div className="sub-item-title" key={_index}>
                                            <div className="icon icon-book"></div>
                                            <a href={_item.url} target="_blank">
                                                {_item.title}
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </Card.Section>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Support);
